export default __webpack_public_path__ + "bb94dea.png";